module.exports = __webpack_public_path__ + "img/wallet-report-blue-2.a58fc025.svg";